/** @format */

export const SELL_BALANCE_ENABLED_FLAG = 'BOO-3170-(sell-balance)';
export const FUZZY_SEARCH_ENABLED_FLAG = 'TUR-2985-(fuzzy-search)';
